import { useCallback, useContext } from 'react';
import InteractionContext from '@atlaskit/interaction-context';
export default function usePressTracing(name) {
  var context = useContext(InteractionContext);
  var handleClick = useCallback(function (timeStamp) {
    if (context) {
      var time = timeStamp || performance.now();
      context.tracePress(name, time);
    }
  }, [context, name]);
  return handleClick;
}